import { render, staticRenderFns } from "./SectionsSidebarTracking.vue?vue&type=template&id=b235e616&scoped=true&"
import script from "./SectionsSidebarTracking.vue?vue&type=script&lang=js&"
export * from "./SectionsSidebarTracking.vue?vue&type=script&lang=js&"
import style0 from "./SectionsSidebarTracking.vue?vue&type=style&index=0&id=b235e616&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b235e616",
  null
  
)

export default component.exports